import { Pipe, PipeTransform } from "@angular/core";

/**
 * Returns a distance.
 *
 * If the distance < 1000 meters, we display the distance as meters
 * otherwise, we return it as kilometers.
 *
 * All of those numbers are rounded.
 *
 * This pipe does not add a unit like "km", or "m".
 */
@Pipe({
    name: "distanceFormatter",
    standalone: false,
})
export class DistanceFormatterPipe implements PipeTransform {
    public transform(meters: number): number {
        if (meters < 1000) {
            return Math.round(meters / 10) * 10;
        }

        return Math.trunc(meters / 1000);
    }
}
